import { RestoreableModel, ResourceFactory } from '../services/';

class User extends RestoreableModel {
  public name: string = '';
  public email: string = '';
  public roles: string[] = ['user'];
  public login_at: Date = null;
  public systems: number[] = [];

  public nameAndEmail() {
    return this.name + ' ' + this.email;
  }
}

const UserFactory = ResourceFactory.create<User>(User, 'user');

export { User, UserFactory };
